import styled from 'styled-components';
import constants from 'src/constants';

const { DEVICE } = constants.breakpoint;

export const ModeButtonsContainer = styled.div`
  position: fixed;
  display: flex;
  flex-direction: column;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  margin-top: 10px;
  z-index: 1;

  @media ${DEVICE.MOBILE} {
    position: fixed;
    display: flex;
    flex-direction: column;
    top: max(env(safe-area-inset-top), 10px);
    right: 10px;
    margin: 0;
    left: auto;
    transform: none;
  }

  @media ${DEVICE.MOBILE_LANDSCAPE} {
    top: 15px;
    right: 45px;
  }
`;

export const ModeButtonRow = styled.div`
  display: flex;
  justify-content: center;
  line-height: 0;

  @media ${DEVICE.MOBILE} {
    display: block;
  }
`;

export const Button = styled.div`
  cursor: pointer;
  box-shadow: 0 2px 3px 0 ${({ theme }) => theme.colors.darkGrayButtonShadow};
  margin-right: 10px;
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(${({ name }) =>
    require(`src/assets/images/${name}-button.svg`)});
  height: 74px;
  width: 74px;

  &:last-child {
    margin-right: 0px;
  }

  @media ${DEVICE.DESKTOP} {
    &:hover {
      background-image: url(${({ name }) =>
        require(`src/assets/images/${name}-button-hover.svg`)});
    }
  }

  @media ${DEVICE.MOBILE} {
    box-shadow: none;
    margin-bottom: 10px;
    margin-right: 0px;
    height: 40px;
    width: 40px;
    background-image: url(${({ name }) =>
      require(`src/assets/images/${name}-button-mobile.svg`)});
  }
`;
